import { useEffect, useState } from 'react';
import { Workbox } from 'workbox-window';

import styles from './UpdatePrompt.module.css';

/**
 * A new service worker never takes over on its own: reloading while someone is typing a
 * transaction would throw their input away (react-pwa-engineering skill 21). The user
 * decides when to update.
 */
export function UpdatePrompt() {
  const [waiting, setWaiting] = useState<Workbox | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator) || import.meta.env.DEV) {
      return;
    }

    const wb = new Workbox('/sw.js');

    wb.addEventListener('waiting', () => {
      setWaiting(wb);
      setDismissed(false);
    });

    // The page reloads only after the new worker has actually taken control.
    wb.addEventListener('controlling', () => {
      window.location.reload();
    });

    void wb.register();
  }, []);

  if (!waiting || dismissed) {
    return null;
  }

  return (
    <div className={styles.prompt} role="status">
      <p className={styles.text}>Có phiên bản mới.</p>
      <button
        type="button"
        className={styles.action}
        onClick={() => {
          void waiting.messageSkipWaiting();
        }}
      >
        Cập nhật
      </button>
      <button
        type="button"
        className={styles.dismiss}
        onClick={() => setDismissed(true)}
        aria-label="Để sau"
      >
        Để sau
      </button>
    </div>
  );
}
